import { useLanguage } from '../context/LanguageContext';
import { ContactForm } from '../components/ContactForm';

export default function Contact() {
  const { t, language } = useLanguage();

  return (
    <div className="relative min-h-screen">
      <section className="relative overflow-hidden py-20 lg:pb-12 lg:pt-32">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 to-slate-950" />

        <div className="relative mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <h1 className="font-outfit text-4xl font-bold leading-tight tracking-tight text-slate-100 sm:text-5xl lg:text-6xl">
            {t.contact.heroTitle}
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-400 lg:text-xl">
            {t.contact.heroSubtitle}
          </p>
        </div>
      </section>

      <section className="bg-slate-950 py-12 lg:py-20">
        <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-8 xl:grid-cols-[240px,minmax(0,1fr)] xl:items-start xl:gap-8">
            <aside className="order-1 xl:sticky xl:top-28">
              <div className="mx-auto flex max-w-[200px] flex-col items-center xl:items-start">
                <div className="mb-4 rounded-2xl border border-cyan-500/20 bg-slate-900/80 p-4 text-sm leading-relaxed text-slate-200 shadow-xl backdrop-blur">
                  {language === 'pt'
                    ? 'Me passa o básico e eu aviso o time certo por aqui.'
                    : 'Share the basics and I will route this to the right team.'}
                </div>

                <img
                  src="/carlinhos-welcome.png"
                  alt="Carlinhos"
                  className="w-full max-w-[170px] drop-shadow-2xl xl:max-w-[185px]"
                />
              </div>
            </aside>

            <div className="order-2 rounded-3xl border border-slate-800 bg-slate-900/50 p-6 backdrop-blur-sm lg:p-10">
              <h2 className="mb-3 font-outfit text-2xl font-bold text-slate-100">{t.contact.formTitle}</h2>
              <p className="mb-8 max-w-2xl text-slate-400">
                {language === 'pt'
                  ? 'Formulário curto, direto e rápido de preencher.'
                  : 'A short, direct form that is quick to fill out.'}
              </p>
              <ContactForm />
            </div>
          </div>

          <p className="mt-8 text-center text-sm text-slate-500">
            {language === 'pt'
              ? 'Também podemos continuar pelo WhatsApp, caso você prefira um contato mais direto.'
              : 'We can also continue on WhatsApp if you prefer a more direct conversation.'}
          </p>
        </div>
      </section>
    </div>
  );
}
